export const version = "sha2/5.0.6";
//# sourceMappingURL=_version.js.map